var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4954_7011",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4954_7011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.67095 9.3167C4.31261 9.3167 4.00289 9.18753 3.74178 8.9292C3.48067 8.67087 3.35011 8.36253 3.35011 8.0042C3.35011 7.64587 3.47928 7.33614 3.73761 7.07503C3.99595 6.81392 4.30428 6.68337 4.66261 6.68337C5.02095 6.68337 5.33067 6.81253 5.59178 7.07087C5.85289 7.3292 5.98345 7.63753 5.98345 7.99587C5.98345 8.3542 5.85428 8.66392 5.59595 8.92503C5.33761 9.18614 5.02928 9.3167 4.67095 9.3167ZM4.66678 12.3834C3.45934 12.3834 2.42695 11.9543 1.56961 11.096C0.712169 10.2379 0.283447 9.20459 0.283447 7.99603C0.283447 6.78759 0.712169 5.75559 1.56961 4.90003C2.42695 4.04448 3.45934 3.6167 4.66678 3.6167C5.55567 3.6167 6.33345 3.82781 7.00011 4.25003C7.66678 4.67225 8.17278 5.28892 8.51811 6.10003H14.3834L16.4668 8.1667L13.4168 10.9834L11.9334 9.88337L10.4834 10.9334L9.16678 9.90003H8.51678C8.239 10.6 7.7705 11.1889 7.11128 11.6667C6.45206 12.1445 5.63722 12.3834 4.66678 12.3834ZM4.66678 11C5.34456 11 5.95845 10.7723 6.50845 10.3167C7.05845 9.86114 7.40011 9.2667 7.53345 8.53337H9.65011L10.4834 9.23337L11.9501 8.18337L13.3168 9.18337L14.5334 8.18337L13.8334 7.4667H7.53345C7.43345 6.80003 7.10789 6.22225 6.55678 5.73337C6.00578 5.24448 5.37578 5.00003 4.66678 5.00003C3.83345 5.00003 3.12511 5.2917 2.54178 5.87503C1.95845 6.45837 1.66678 7.1667 1.66678 8.00003C1.66678 8.83337 1.95845 9.5417 2.54178 10.125C3.12511 10.7084 3.83345 11 4.66678 11Z",
    fill: "#253037"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyBlack);
export default __webpack_public_path__ + "static/media/key_black.5e38155b1741c41825c0cdcdf91d4e9c.svg";
export { ForwardRef as ReactComponent };